<template>
  <div class="flex h-auto bg-gray-900 text-white">
    <!-- Sidebar -->
    <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg border border-gray-700 bg-gradient-to-b from-gray-800 to-gray-900">
      <div class="flex items-center justify-center space-x-3">
        <img src="@/assets/logo.svg" alt="Vultric Logo" class="h-20" />
      </div>
      <Navbar />
    </aside>

    <!-- Main Content -->
    <div class="flex-1 flex flex-col">
      <Header />

      <main class="p-6 flex-1">
        <div class="flex justify-between items-center mb-6">
          <h3 class="text-2xl font-bold">Active Servers</h3>
          <button
            @click="deployServer"
            class="px-4 py-2 bg-blue-500 text-white font-semibold rounded-full hover:bg-blue-600 transition"
          >
            Deploy New Server
          </button>
        </div>

        <!-- Modern Table -->
        <div class="overflow-x-auto bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700 rounded-xl shadow-lg">
          <table class="min-w-full text-left border-collapse">
            <thead class="bg-gray-800">
              <tr>
                <th class="px-4 py-3 font-semibold uppercase text-gray-300 tracking-wider">Server Name</th>
                <th class="px-4 py-3 font-semibold uppercase text-gray-300 tracking-wider">Status</th>
                <th class="px-4 py-3 font-semibold uppercase text-gray-300 tracking-wider">IP Address</th>
                <th class="px-4 py-3 font-semibold uppercase text-gray-300 tracking-wider">OS</th>
                <th class="px-4 py-3 font-semibold uppercase text-gray-300 tracking-wider">Location</th>
                <th class="px-4 py-3 font-semibold uppercase text-gray-300 tracking-wider">Charges</th>
              </tr>
            </thead>
          <tbody>
            <tr
              v-for="server in servers"
              :key="server.id"
              class="border-b border-gray-700 hover:bg-gray-700 transition cursor-pointer"
              @click="goToServer(server.id)"
            >
              <!-- Server Name -->
              <td class="px-4 py-3 font-medium">{{ server.servername }}</td>

              <!-- Status -->
              <td class="px-4 py-3">
                <span
                  :class="statusClass(server.status)"
                  class="px-2 py-1 rounded-full text-sm font-medium"
                >
                  {{ server.status }}
                </span>
              </td>

              <!-- IP Address -->
              <td class="px-4 py-3">{{ server.ipaddress }}</td>

              <!-- OS -->
              <td class="px-4 py-3">
                <img
                  :src="getOSImage(server.osImage)"
                  :alt="server.os"
                  class="w-12 h-11 mr-2"
                />
              </td>

              <!-- Location -->
              <td class="px-4 py-3 flex items-center">
                <img
                  :src="getCountryFlag(server.country)"
                  :alt="server.location"
                  class="w-8 h-6 mr-2"
                />
                <span>{{ server.location }}</span>
              </td>

              <!-- Charges -->
              <td class="px-4 py-3 font-semibold">${{ parseFloat(server.charges).toFixed(2) }}/mo</td>
            </tr>
          </tbody>
          </table>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/nav.vue";
import Header from "@/components/header.vue";
import axios from "axios";

export default {
  name: "CloudServersTable",
  components: { Navbar, Header },
  data() {
    return {
      servers: [],
      interval: null,
    };
  },
  methods: {
    async fetchServers() {
      try {
        const { data } = await axios.get("https://api.syniac.com:3000/api/server/listServers", {
          withCredentials: true,
        });
        this.servers = data.servers;
      } catch (error) {
        console.error("Error fetching servers:", error);
      }
    },
    statusClass(status) {
      return {
        "bg-green-600 text-green-100": status === "Running",
        "bg-yellow-600 text-yellow-100": status === "Installing",
        "bg-red-600 text-red-100": status === "Stopped",
      };
    },
    getOSImage(osImage) {
      return require(`@/assets/operatingsystems/${osImage}.svg`);
    },
    getCountryFlag(country) {
      return require(`@/assets/countryflags/${country}.svg`);
    },
    goToServer(id) {
      this.$router.push(`/manage/${id}`);
    },
    deployServer() {
      this.$router.push("/order");
    },
  },
  created() {
    this.fetchServers();
    this.interval = setInterval(this.fetchServers, 60000);
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
};
</script>

<style>
/* Optional hover animation for smooth feel */
tbody tr:hover {
  transition: background-color 0.3s;
}
</style>
